// @flow
export const SET_BOOST_HEATING_HOTWATER = 'hive/heating-hotwater/boost/set';
export const SET_HOT_WATER_STATUS = 'hive/heating-hotwater/status/set';
export const SET_HOT_WATER_STATUS_SUCCESSFUL = 'hive/heating-hotwater/status/set-success';
export const SET_HOT_WATER_STATUS_UPDATE_PRODUCT = 'hive/heating-hotwater/status/set-update-product';
export const STOP_BOOST_HEATING_HOTWATER = 'hive/heating-hotwater/boost/stop';
export const TIMEOUT_BOOST_HEATING_HOTWATER = 'hive/heating-hotwater/boost/timeout';
export const TOGGLE_HOT_WATER = 'hive/heating-hotwater/toggle';
export const TOGGLE_HOT_WATER_DONE = 'hive/heating-hotwater/toggle-done';



// WEBPACK FOOTER //
// ./src/core/state/products/heating-hotwater/constants.js